import React, { FC, useCallback } from 'react'
import { ISelectOption } from 'components/forms/Selects'
import { SingleSelect } from 'transfix-ui/components/SingleSelect'
import { IFilterInputProps } from 'apps/fleet-planner/pages/loads/FilterFacilityLocation'
import { ILoadFilters } from 'apps/fleet-planner/types'
import { ClockIcon } from 'transfix-icons'
import { DEFAULT_MAX_AGE } from './const'

export interface IFilterMaxAgeProps
  extends IFilterInputProps<Partial<Pick<ILoadFilters, 'maxAge'>>> {}

const options: ISelectOption<Number>[] = [
  { label: 'Last 30 days', value: 30 },
  { label: 'Last 60 days', value: 60 },
  { label: 'Last 90 days', value: 90 },
]

export const FilterMaxAge: FC<IFilterMaxAgeProps> = ({
  onChange: onChangeProp,
  value: valueProp,
}) => {
  const selectHandler = useCallback(
    (change?: ISelectOption<any> | undefined) => {
      const { value } = change || {}
      const maxAge = Math.floor(Number(value) || 0)
      onChangeProp({ maxAge })
    },
    [onChangeProp]
  )
  const { maxAge = DEFAULT_MAX_AGE } = valueProp || {}

  return (
    <SingleSelect
      id='loads-driver-filter'
      dataTest='loads-driver-filter'
      icon={<ClockIcon size='large' />}
      label='Shipment Age'
      options={options}
      onSelect={selectHandler}
      selected={maxAge}
      emptyStateLabel='Unlimited'
    />
  )
}
